export default __webpack_public_path__ + "static/Inter-Bold-3e3cb905bf27a4c8c370fd245d959030.ttf";